var _defs, _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconOk = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}.b{}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-531 -505)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16,
    transform: "translate(531 505)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-11236.173-14613.343a.993.993,0,0,1-.707-.291l-1.412-1.417a.994.994,0,0,1,0-1.412.994.994,0,0,1,1.412,0l.707.705,3.534-3.534a1,1,0,0,1,1.417,0,1,1,0,0,1,0,1.413l-4.242,4.245a1,1,0,0,1-.708.291Z",
    transform: "translate(11773.758 15130.171)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconOk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-ok.b4c712db.svg";
export { ForwardRef as ReactComponent };